import React from "react";
import { Helmet } from "react-helmet";
import {
  greeting,
  seo,
  socialMediaLinks,
  contactPageData,
  certifications,
} from "../../portfolio.js";

function SeoHeader() {
  // Social links that are not tel/mailto
  const sameAs =
    socialMediaLinks
      ?.filter(
        (media) =>
          !media.link.startsWith("tel") && !media.link.startsWith("mailto")
      )
      .map((media) => media.link) || [];

  // Email from mailto link (if exists)
  const mail = socialMediaLinks
    ?.find((media) => media.link.startsWith("mailto"))
    ?.link?.replace("mailto:", "");

  // First work experience (may not exist if you removed Work section)
  // Credentials from certifications
  const credentials =
    certifications?.certifications?.map((cert) => ({
      "@context": "https://schema.org",
      "@type": "EducationalOccupationalCredential",
      url: cert.certificate_link,
      name: cert.title,
      description: cert.subtitle,
    })) || [];

  const og = seo?.og || {};

  const data = {
    "@context": "https://schema.org/",
    "@type": "Person",
    name: greeting?.title || "Portfolio",
    url: og.url,
    email: mail,
    telephone: contactPageData?.phoneSection?.subtitle,
    sameAs,
    address: {
      "@type": "PostalAddress",
      addressLocality: contactPageData?.addressSection?.locality,
      addressRegion: contactPageData?.addressSection?.region,
      addressCountry: contactPageData?.addressSection?.country,
      postalCode: contactPageData?.addressSection?.postalCode,
      streetAddress: contactPageData?.addressSection?.streetAddress,
    },
    hasCredential: credentials,
  };

  return (
    <Helmet>
      <title>{seo?.title || greeting?.title || "Portfolio"}</title>
      {seo?.description && (
        <meta name="description" content={seo.description} />
      )}
      {og.title && <meta property="og:title" content={og.title} />}
      {og.type && <meta property="og:type" content={og.type} />}
      {og.url && <meta property="og:url" content={og.url} />}
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

export default SeoHeader;
